import { render, staticRenderFns } from "./vendor_sites_tel.vue?vue&type=template&id=4ab764ba&scoped=true&"
import script from "./vendor_sites_tel.vue?vue&type=script&lang=js&"
export * from "./vendor_sites_tel.vue?vue&type=script&lang=js&"
import style0 from "./vendor_sites_tel.vue?vue&type=style&index=0&id=4ab764ba&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ab764ba",
  null
  
)

export default component.exports